export class AutoCompleteHelper {
  constructor(autoCompleteSelectNode) {
    if (!autoCompleteSelectNode) return
    addListenerToCountryInput.execute(autoCompleteSelectNode)
  }
}

const addListenerToCountryInput = {
  execute: (autoCompleteSelectNode) => {
    const autoCompleteInputElement = autoCompleteSelectNode.parentNode?.querySelector?.('input')
    if (autoCompleteInputElement) {
      attachToInput(autoCompleteInputElement, autoCompleteSelectNode)
    }
  }
}

const attachToInput = (inputEl, autoCompleteSelectNode) => {
  const attributeName = inputEl.getAttribute('id')
  inputEl.addEventListener('input', () => {
    try {
      autoCompleteSelectNode.value = ''
      autoCompleteSelectNode.selectedIndex = -1
      autoCompleteSelectNode.removeAttribute('name')
    } catch {
      //noop
    }
    syncName(inputEl, autoCompleteSelectNode, attributeName)
  })
  inputEl.addEventListener('blur', () => syncName(inputEl, autoCompleteSelectNode, attributeName))
  inputEl.addEventListener('change', () => syncName(inputEl, autoCompleteSelectNode, attributeName))
}

const syncName = (sourceEl, autoCompleteSelectNode, attributeName) => {
  if (sourceEl.value === '') {
    autoCompleteSelectNode.removeAttribute('name')
  } else {
    autoCompleteSelectNode.setAttribute('name', attributeName)
  }
}
